import React from "react";
import Input from "../../../../widget/common/form/Input";
import { CountryStateCityAreaContextImport } from "../../../../provider/country_state_city_area/country_state_city_area/CountryStateCityAreaContextProvider";
import { textCase } from "../../../../service/ui/UI";
import { OffOn } from "../../../../widget/common/ui/Checkbox";

export const CountryStateCityAreaCountryField = () => {
  const { country, changeFlag } = CountryStateCityAreaContextImport();

  return (
    <div role="button" onClick={() => changeFlag("1")}>
      <Input
        type="text"
        name="coutnry_name"
        handleOnChange={() => {}}
        value={country == null ? "" : textCase(country?.country_name! ?? "")}
        readOnly={true}
        label="country"
        suffixType="icon"
        suffixIcon="arrow_right"
        suffixIconFill={true}
      />
    </div>
  );
};

export const CountryStateCityAreaStateField = () => {
  const { state, changeFlag } = CountryStateCityAreaContextImport();

  return (
    <div role="button" onClick={() => changeFlag("2")}>
      <Input
        type="text"
        name="state_name"
        handleOnChange={() => {}}
        value={state == null ? "" : textCase(state?.state_name! ?? "")}
        readOnly={true}
        label="state"
        suffixType="icon"
        suffixIcon="arrow_right"
        suffixIconFill={true}
      />
    </div>
  );
};

export const CountryStateCityAreaCityField = () => {
  const { city, changeFlag } = CountryStateCityAreaContextImport();

  return (
    <div role="button" onClick={() => changeFlag("3")}>
      <Input
        type="text"
        name="city_town"
        handleOnChange={() => {}}
        value={city == null ? "" : textCase(city?.city_name! ?? "")}
        readOnly={true}
        label="city_town"
        suffixType="icon"
        suffixIcon="arrow_right"
        suffixIconFill={true}
      />
    </div>
  );
};

export const CountryStateCityAreaSuburbField = () => {
  const { area, changeFlag } = CountryStateCityAreaContextImport();

  return (
    <div role="button" onClick={() => changeFlag("4")}>
      <Input
        type="text"
        name="suburb"
        handleOnChange={() => {}}
        value={area == null ? "" : textCase(area?.area_name! ?? "")}
        readOnly={true}
        label="suburb"
        suffixType="icon"
        suffixIcon="arrow_right"
        suffixIconFill={true}
      />
    </div>
  );
};

export const CountryStateCityAreaNearByField = () => {
  const { nearByStatus, handleNearBy } = CountryStateCityAreaContextImport();

  return (
    <div>
      <OffOn
        name="toggle-nearby"
        value={nearByStatus}
        handleOnChange={handleNearBy}
      />
    </div>
  );
};
